import { useNavigate, useSearch } from '@tanstack/react-router'
import { useState } from 'react'

import { Card, Link, SpreadsheetBackground } from '@/components/ui'
import { AuthForm, OtpForm, useAuthMutations } from '@/modules/auth'
import { getCourtoisPrivacyUrl, getCourtoisTermsUrl } from '@/services/courtois'

type UserSignUpPage = 'email' | 'otp'

export const UserSignUpPage = () => {
  const navigate = useNavigate()
  const { redirect } = useSearch({ from: '/user-sign-up' })
  const [email, setEmail] = useState('')
  const [state, setState] = useState<UserSignUpPage>('email')
  const { signUp } = useAuthMutations()

  const handleEmailSubmit = (email: string) => {
    setEmail(email)
    return signUp({ email }).then(() => setState('otp'))
  }

  const navigateAfterLogin = () => {
    navigate({ to: redirect ?? '/' })
  }

  const handleDifferentEmail = () => {
    setState('email')
    setEmail('')
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4 relative overflow-hidden">
      <SpreadsheetBackground />
      <div className="w-full max-w-105 relative z-10">
        <div className="flex flex-col items-center">
          <div className="mb-10">
            <img src="/logo.svg" alt="CounselPro" className="h-10 w-auto" />
          </div>

          <Card className="w-full">
            {state === 'email' && (
              <AuthForm
                onSubmit={handleEmailSubmit}
                onSignedIn={navigateAfterLogin}
                title="Sign up to your user account"
                description="Enter the email you used to receive the invitation."
                footerTitle="Existing user"
                footerLabel="Already have an account?"
                footerLink={{ to: '/login', label: 'Sign in' }}
              />
            )}

            {state === 'otp' && (
              <OtpForm
                email={email}
                onCodeVerified={navigateAfterLogin}
                onReturn={handleDifferentEmail}
                isLogin
              />
            )}
          </Card>

          <p className="mt-8 text-center text-xs text-muted-foreground max-w-sm">
            By continuing, you agree to our{' '}
            <Link href={getCourtoisTermsUrl()} size="xs" newTab>
              Terms of Service
            </Link>{' '}
            and{' '}
            <Link href={getCourtoisPrivacyUrl()} size="xs" newTab>
              Privacy Policy
            </Link>
            .
          </p>
        </div>
      </div>
    </div>
  )
}
